<template>
  <div class="poster" id="vote-poster">
    <img
      class="poster-image"
      @load="bindImageLoaded"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/16cbaae102ed320f789ff5d1eb286873.png"
      alt=""
    />
    <div class="user-info" v-if="data">
      <div class="nickname">{{ data.nickname }}</div>
      <div>邀请您</div>
    </div>
    <img
      class="add-coach"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d588ee0621d3887b550851d3d2ae529d.jpg"
      alt=""
    />
    <div class="qrcode">
      <canvas id="qrcode"></canvas>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode'
export default {
  props: {
    qrcode: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loaded: false,
      isCreateQrcode: false
    }
  },
  mounted() {},
  methods: {
    bindImageLoaded() {
      this.loaded = true
    },
    createQrcode() {
      return new Promise((resolve, reject) => {
        if (this.isCreateQrcode) {
          resolve(true)
          return
        }
        //计算出二维码的实际宽度
        let screenWidth = window.screen.width
        let designWidth = 375
        let designQrcodeWidth = 80
        let qrcodeWidth = (screenWidth * designQrcodeWidth) / designWidth
        let canvas = document.getElementById('qrcode')
        if (!canvas) {
          reject(false)
          return
        }
        QRCode.toCanvas(
          canvas,
          this.qrcode,
          { width: qrcodeWidth, height: qrcodeWidth },
          (error) => {
            console.log(error)
            if (error) {
              reject(false)
            } else {
              this.isCreateQrcode = true
              resolve(true)
            }
          }
        )
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.poster {
  position: fixed;
  z-index: 2;
  left: 500%;
  top: 0%;
  width: 301px;
  border-radius: 8px;

  .poster-image {
    width: 300px;
    height: 537px;
  }

  .user-info {
    width: 260px;
    position: absolute;
    left: 22px;
    top: 56px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;

    .nickname {
      margin-right: 7px;
      font-size: 14px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-weight: 400;
      max-width: 150px;
    }
  }

  .add-coach {
    position: absolute;
    left: 178px;
    bottom: 60px;
    width: 80px;
    height: 80px;
    box-sizing: border-box;
    border: 4px solid transparent;
  }

  .qrcode {
    position: absolute;
    left: 41px;
    bottom: 60px;
    width: 80px;
    height: 80px;
    #qrcode {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
